

































































import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { saveScroll, setScroll } from '@/plugins/save-position';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

@Component
export default class UserUnits extends Vue {
    public staffUnitsId: string = 'hoc-adminapp-units';

    public propertiesSearchQuery: string = '';
    private keyboardListenerAdded: boolean = false;

    constructor() {
        super();

        this.initializeKeyboardListener();
    }

    public initializeKeyboardListener(): void {
        if (this.keyboardListenerAdded === true) {
            return;
        }

        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            this.keyboardListenerAdded = true;
            return;
        }

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, true);
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, false);
        });

        this.keyboardListenerAdded = true;
    }

    get properties() {
        let properties = this.$store.getters['StaffProperties/getStaffProperties'];

        if (this.propertiesSearchQuery.trim() !== '') {
            properties = properties.filter((property: any) => {
                return  property.id === Number(this.propertiesSearchQuery) ||
                    property.address.toLowerCase().includes(this.propertiesSearchQuery.toLowerCase());
            });
        }

        return properties;
    }

    public goToUnitDetails(property: any) {
        this.$store.commit(Mutations.SET_STAFF_CURRENT_PROPERTY, property);
        this.$router.push({path: `/user/units/${property.id}`});
    }

    public tenantsCount(property: any) {
        return property.primary_tenant
            ? property.tenants.length + 1
            : property.tenants.length;
    }

    public canMessage(property: any) {
        return property.primary_tenant && property.primary_tenant.name !== 'N/A'
            ? property.tenants.length + 1
            : property.tenants.length;
    }

    public createUnitConversation(propertyId: number) {
        this.$store.dispatch(Actions.INITIALIZE_PROPERTY_CONVERSATION, propertyId);
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('header.units', 'Units'));
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffLanguageButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.UserProfileButton);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_STAFF_PROPERTIES);
    }

    public mounted() {
        setScroll(this.staffUnitsId, 'getStaffAppPagePosition');
    }

    public beforeRouteLeave(to, from, next) {
        saveScroll(this.staffUnitsId, Mutations.SET_STAFF_APP_PAGE_SCROLL_POSITION);
        next();
    }
}
